// import Dialog from "~/components/molecules/Dialog"
import { inject, Observer } from "mobx-react"
import { WithRouterProps } from "next/dist/client/with-router"
import Head from "next/head"
import { withRouter } from "next/router"
import React from "react"

import CourseApplyDoneModal from "~/components/organisms/CourseApplyDoneModal"
import CourseInputPersonalDataModal from "~/components/organisms/CourseInputPersonalDataModal"
import CourseSchduleSelectModal from "~/components/organisms/CourseSchduleSelectModal"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import Background from "~/components/organisms/course-detail/Background"
import Consultation from "~/components/organisms/course-detail/Consultation"
import Curriculum from "~/components/organisms/course-detail/Curriculum"
import MainVisual from "~/components/organisms/course-detail/MainVisual"
import Price from "~/components/organisms/course-detail/Price"
import PromoteArea from "~/components/organisms/course-detail/PromoteArea"
import Teacher from "~/components/organisms/course-detail/Teacher"
import { Course } from "~/entities/Course"
import { TmpUserInfo } from "~/entities/User"
import { staticPath } from "~/services/helper"
import ApplicationStore from "~/stores/ApplicationStore"
import RootStore from "~/stores/RootStore"
import UiStore from "~/stores/UiStore"
import UserStore from "~/stores/UserStore"

interface Props {
  applicationStore: ApplicationStore
  course: Course
  uiStore: UiStore
  userStore: UserStore
}

interface State {
  selectedScheduleValues: string[]
  isLoading: boolean
  tmpUserInfo: TmpUserInfo
}

@inject("applicationStore", "uiStore", "userStore")
class SalesCourse extends React.Component<WithRouterProps & Props, State> {
  static async getInitialProps({ initialStoreData }: { initialStoreData: RootStore }) {
    const { courseStore } = initialStoreData
    const course = await courseStore.fetchById(3)
    return { course }
  }

  state = {
    selectedScheduleValues: [],
    isLoading: false,
    tmpUserInfo: {
      name: null,
      phoneNumber: null,
    },
  }

  constructor(props: WithRouterProps & Props) {
    super(props)
    const { uiStore } = props
    switch (props.router.query.openModal) {
      case "selectSchedule":
        uiStore.toggleCourseSchduleSelectModal()
        break
      case "confirmApply":
        uiStore.toggleConfirmCourseApplyModal()
        break
      case "applyComplete":
        uiStore.toggleCompleteApplyCourseModal()
        break
    }
  }

  render() {
    const { applicationStore, course, uiStore, userStore } = this.props
    const { selectedScheduleValues, isLoading, tmpUserInfo } = this.state
    const handleSelectSchedule = (schedules: string[]) => {
      this.setState({
        selectedScheduleValues: schedules,
      })
    }
    const toggleLoading = () => {
      this.setState({
        isLoading: !this.state.isLoading,
      })
    }

    const updateTmpUserInfo = (values: TmpUserInfo) => {
      this.setState({
        tmpUserInfo: values,
      })
    }

    const mainActionForSchduleSelectModal = async () => {
      toggleLoading()
      selectedScheduleValues.sort()
      if (userStore.authed) {
        await applicationStore.courseConsultationApply(3, selectedScheduleValues.sort())
      } else {
        await applicationStore.courseConsultationApplyByGuest(3, tmpUserInfo, selectedScheduleValues.sort())
      }
      uiStore.toggleCourseSchduleSelectModal()
      uiStore.toggleCompleteApplyCourseModal()
      toggleLoading()
    }

    return (
      <>
        <Head>
          <title>営業講座 | Infra（インフラ）</title>
          <meta name="description" content={course.description} />
          <meta name="og:title" content="営業講座 | Infra（インフラ）" />
          <meta name="og:description" content={course.description} />
          <meta
            property="og:image"
            content={`${process.env.APP_HOST + staticPath("/static/images/course/sales/ogp.png")}`}
          />
        </Head>
        <Header logoType="Courses" showTab />
        <MainVisual
          mSrcPc={staticPath("/static/images/course/sales/mv.png")}
          mSrcSp={staticPath("/static/images/course/sales/mv-sp.png")}
          typoPath={staticPath("/static/images/course/sales/typo.svg")}
          heading="営業講座"
          description="本講座は未経験からプロのセールススキルを身につけることの出来るオンライン型集中プログラムです。法人営業に必要な基礎知識はもちろんのこと、現場で活用出来るアウトバウンド営業、インサイドセールス、オンラインセールスのノウハウを身に付けることが出来ます。"
          disabled
        />
        <Background
          message={`営業力はビジネス職において最も基礎になるスキルの一つです。また、会社員だけでなくフリーランスや独立起業にも営業力は不可欠なスキルです。
          人間の仕事の半分以上がAIやロボットに奪われる——そんな未来予測が話題となっている昨今ですが、AI時代も本質的に価値のある営業マンは必要不可欠です。
          営業ノウハウや知識を共有し、営業活動に「テクノロジー」を活用したい企業は年々増加しています。IT化が進む中でセールステック×データの活用で新しい営業プロセス、スキルセットが必須の時代です。
          `}
        />
        <PromoteArea bgPath={staticPath("/static/images/course/sales/mv.png")} courseName="営業講座" disabled />
        <Teacher
          items={[
            {
              img: staticPath("/static/images/course/sales/teacher-1.jpg"),
              name: "母壁 和樹",
              position: "ギグセールス株式会社 取締役",
              introduction:
                "不動産賃貸管理でのオーナー獲得からの営業経験を生かし、０から新規開拓営業に2018年より参画。アウトバウンド型の営業支援をインサイドセールス・フィールドセールスと経験し、プロジェクトのディレクション業務も兼任しながら、案件を効果的にPDCAサイクルさせて営業構築する事に従事。",
            },
          ]}
        />
        <PromoteArea bgPath={staticPath("/static/images/course/sales/mv.png")} courseName="営業講座" disabled />
        <Curriculum
          heading="プロのスキルを2ヶ月に凝縮"
          period="第1期 2020年6月24日（水）19:00開講"
          curriculumItems={[
            {
              periodImgPc: staticPath("/static/images/course/period-2month-pc.svg"),
              periodImgSp: staticPath("/static/images/course/period-2month-sp.svg"),
              heading: "全10回",
              date: "オンライン完結",
              caption: "1. 法人営業とは",
              body: "└ アウトバウンド営業（プッシュ型）、インバウンド営業（プル型）\n└ アウトバウンド、インバウンド営業の必要性\n└ 法人営業における新規開拓の基本セット（全体的な営業戦略全般）",
            },
            {
              caption: "2. 法人営業の種類",
              body: "└ 営業手法\n└ 各手法別の特徴\n└ 現代にマッチした手法の紹介",
            },
            {
              caption: "3. 法人営業に必要なマインドセット",
              body: "└ KGIから逆算したKPIの設定\n└ 各営業プロセス毎の必要数値",
            },
            {
              caption: "4. 法人営業に必要な要件",
              body: "└ PDCAの回し方\n└ 情報収集の構築方法\n└ ノウハウ蓄積とケーススタディの収集\n└ 行動計画の策定と実行",
            },
            {
              caption: "5. 新規顧客開拓の方法",
              body: "└ アウトバウンド、インバウンドによる顧客開拓手法\n└ リードジェネレーション手法\n└ リードナーチャリング手法",
            },
            {
              caption: "6. それぞれの営業手法",
              body: "└ テレアポ（アウトバウンドコール）\n└ メール営業\n└ 飛び込み営業\n└ オウンドメディア（ホワイトペーパーDL）\n└ 顧客紹介（リファラル）etc ...",
            },
            {
              caption: "7. 営業プロセス",
              body: "└ ターゲット設定とリスト作成\n└ アプローチ先の優先順位付け\n└ 架電時のトークスクリプト作成",
            },
            {
              caption: "8. セールスの連携フローと各役割",
              body: "└ 各プロセス毎の業務とKPI設定\n└ 役割分担で実行プロセスの検証",
            },
            {
              caption: "9. オンラインセールスに必要とされるスキル・ツール",
              body: "└ オンラインセールスに必要なスキルセット\n└ オンライン商談ツール\n└ オンラインリードの獲得（makibisi、SalesDoc、セールスレターなど）",
            },
            {
              caption: "10. テレワーク時代、今後必要になる専門スキルとは",
              body: "└ オンライン商談スキル\n└ セールスイネーブルメントツール\n└ 動画による商談ログの蓄積と分析",
            },
          ]}
          recommendItems={[
            "営業を全くやったことがないが、営業に興味がある方",
            "これから営業職としてインターン/就職するにあたって、周りより一歩先を行きたい方",
            "営業の長期インターンをしていて、なかなか成果が出せずに悩んでいる方",
            "今後企業の営業職としてトップセールスを目指している方",
          ]}
        />
        <PromoteArea bgPath={staticPath("/static/images/course/sales/mv.png")} courseName="営業講座" disabled />
        <Price
          items={[
            {
              price: 88000,
              originalPrice: 108000,
              splitNum: 5,
            },
          ]}
          typeSales
        />
        <PromoteArea bgPath={staticPath("/static/images/course/sales/mv.png")} courseName="営業講座" disabled />
        <Consultation job="営業職" />
        <PromoteArea bgPath={staticPath("/static/images/course/sales/mv.png")} courseName="営業講座" disabled />
        <Observer>
          {() => (
            <>
              {/* <Dialog
                open={uiStore.authPromptModalOpen}
                heading="登録またはログインが必要です"
                mainAction={{
                  label: "登録する",
                  action: () =>
                    window.open(uiStore.redirectUrlAfterAuth, "_self"),
                }}
                subAction={{
                  label: "キャンセル",
                  action: () => uiStore.toggleAuthPromptModal(),
                }}
              >
                エントリー/お気に入りを利用するためには、新規登録またはログインが必要です。
              </Dialog> */}
              {/* <Dialog
                open={uiStore.confirmCourseApplyModalOpen}
                heading="講座申し込みの確認"
                mainAction={{
                  label: "申し込む",
                  action: async () => {
                    toggleLoading()
                    uiStore.toggleConfirmCourseApplyModal()
                    uiStore.toggleCompleteApplyCourseModal()
                    // 広告CV設定のため、敢えてリロードさせる
                    location.href = `${
                      process.env.APP_HOST + location.pathname
                    }?openModal=applyComplete`
                    toggleLoading()
                  },
                  className: "gtm_course-complete-application",
                  isLoading: isLoading,
                }}
                subAction={{
                  label: "キャンセル",
                  action: () => uiStore.toggleConfirmCourseApplyModal(),
                }}
              >
                こちらの講座は<PaidAlert>有料</PaidAlert>となります。
                <br />
                申し込みを確定してよろしいですか？
              </Dialog> */}
              <CourseInputPersonalDataModal
                open={uiStore.authPromptModalOpen}
                close={() => uiStore.toggleAuthPromptModal()}
                updateTmpUserInfo={updateTmpUserInfo}
                mainAction={() => {
                  uiStore.toggleAuthPromptModal()
                  uiStore.toggleCourseSchduleSelectModal()
                }}
              />
              <CourseSchduleSelectModal
                open={uiStore.courseSchduleSelectModalOpen}
                selectedScheduleValues={selectedScheduleValues}
                onSelectSchedule={handleSelectSchedule}
                mainAction={mainActionForSchduleSelectModal}
                subAction={() => uiStore.toggleCourseSchduleSelectModal()}
                isLoading={isLoading}
              />
              <CourseApplyDoneModal
                open={uiStore.completeApplyCourseModalOpen}
                close={() => uiStore.toggleCompleteApplyCourseModal()}
                addFriend={() => window.open(course.lineUrl)}
                lineQrImageUrl={course.lineQrImageUrl}
              />
            </>
          )}
        </Observer>
        <Footer />
      </>
    )
  }
}

export default withRouter(SalesCourse)
